"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Product_module_1 = require("./modules/Product.module");
const loadProductContentVideoModule = initialData => ({
    hasRouter: false,
    modules: [(0, Product_module_1.default)(initialData)],
});
exports.default = loadProductContentVideoModule;
